import {
  createBrowserRouter,
  redirect,
} from "react-router-dom";
import type {  } from "react-router-dom";
import { authProvider } from "./auth";

import { SignUpPage, signupLoader, signupAction } from "./components/Signup";
import { LoginPage, LogoutPage, loginLoader, loginAction } from "./components/Login";
import { Course, Courses } from "./components/Protected/Courses";
import { NewCourse } from "./components/Protected/NewCourse";
import { People } from "./components/Protected/People";
import { Info } from "./components/Info";
import { Profile } from "./components/Protected/Profile";
import { PersonCreator } from "./components/Protected/PersonCreator";
import { AdminTools } from "./components/Protected/AdminTools";
import { Dashboard } from "./components/Protected/Dashboard";
import { Attendance } from "./components/Protected/AttendanceDashboard";
import { Onboarding } from "./components/Protected/Onboarding";
import { Tags } from "./components/Protected/Tags";
import { Layout } from "./components/Layout";

import { PATHS } from './paths'

import { genericLoader } from "./utils";

const router = createBrowserRouter([
  {
    id: "root",
    path: PATHS.ROOT,
    // TODO: setup a proper fail page
    //errorElement: "win",
    Component: Layout,
    children: [
      {
        index: true,
        action: loginAction,
        loader: loginLoader,
        Component: LoginPage,
      },
      {
        path: PATHS.LOGIN,
        action: loginAction,
        loader: loginLoader,
        Component: LoginPage,
      },
      {
        path: PATHS.INFO,
        Component: Info,
      },
      {
        path: PATHS.SIGNUP,
        action: signupAction,
        loader: signupLoader,
        Component: SignUpPage,
      },
      {
        path: PATHS.COURSES,
        loader: genericLoader,
        Component: Courses,
      },
      {
        path: PATHS.COURSE,
        loader: genericLoader,
        Component: Course,
      },
      {
        path: PATHS.COURSE_CREATE,
        loader: genericLoader,
        Component: NewCourse,
      },
      {
        path: PATHS.PEOPLE,
        loader: genericLoader,
        Component: People,
      },
      {
        path: PATHS.PERSON,
        loader: genericLoader,
        Component: Profile,
      },
      {
        path: PATHS.PEOPLE_CREATE,
        loader: genericLoader,
        Component: PersonCreator,
      },
      {
        path: PATHS.ADMIN_TOOLS,
        loader: genericLoader,
        Component: AdminTools,
      },
      {
        path: PATHS.DASHBOARD,
        loader: genericLoader,
        Component: Dashboard,
      },
      {
        path: PATHS.ATTENDANCE,
        loader: genericLoader,
        Component: Attendance,
      },
      {
        path: PATHS.ONBOARDING,
        loader: genericLoader,
        Component: Onboarding,
      },
      {
        path: PATHS.TAGS,
        loader: genericLoader,
        Component: Tags,
      },
    ],
  },
  {
    path: PATHS.LOGOUT,
    Component: LogoutPage,
    async loader() {
      await authProvider.signout();
      return redirect(PATHS.ROOT);
    },
  },
]);


export { router };
